import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { VideosFacade } from '../facades/videos.facade';

export function videoCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const videosFacade = inject(VideosFacade);
        videosFacade.clear();

        return true;
    };
}
